/*
 * @Date: 2024-08-28 17:56:12
 * @LastEditors: Leo
 * @LastEditTime: 2024-08-28 17:56:12
 * @description: globaljs - 全局功能组件
 */
import './index.less'
import DetailsDisclosure from '../../components/details-disclosure'
import QuantityInput from '../../components/quantity-input'
import DetailsModal from '../../components/details-modal'
import {CartDrawer, CartDrawerItems, CartRemoveButton, CartItems} from "../../components/cart-drawer"
import {pushMessage, pushSuccessMessage, pushErrorMessage } from "../../components/jky-toast/init-toast"
import jkyVideo from '../../components/jky-video'
import jkyForm from "../../components/jky-form";
import ZModle from "../../components/z-modal"
import ZModleNew from "../../components/z-modal-new"
import ZModleBFCM  from "../../components/z-modal-bfcm"
import fixedIcons from '@plugins/fixed-icons'
import {SocialSharePopup} from "../../components/social-share-popup";
import '../../components/common-three/pdp-single-text-img.less'
// import '../../components/common-three/pdp-three-text-img.less'
// import '../../components/common-three/pdp-two-text-img.less'
import '../../components/common-three/pdp-common.less'
import '../../components/common-three/pdp-calculator.less'
import { PdpCalculator } from '../../components/common-three/pdp-calculator';

customElements.define('details-disclosure', DetailsDisclosure);
customElements.define('details-modal', DetailsModal);

// 购物车相关组件
customElements.define('cart-remove-button', CartRemoveButton);
customElements.define('cart-items', CartItems);
customElements.define('cart-drawer', CartDrawer);
customElements.define('cart-drawer-items', CartDrawerItems);
customElements.define('quantity-input', QuantityInput);

// 全局悬浮提示组件
window.pushMessage = pushMessage;
window.pushSuccessMessage = pushSuccessMessage;
window.pushErrorMessage = pushErrorMessage;

window.$(document).ready(function() {
  window.ZModle = ZModle
  window.ZModleNew = ZModleNew
  window.ZModleBFCM  = ZModleBFCM
  jkyVideo()
  jkyForm()

  // 全局公共社交分享弹窗
  SocialSharePopup();
})

// 插件懒加载
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    fixedIcons()          // 全局悬浮 icons

    // 通知
    import(/* webpackChunkName: "notification" */ '../../plugins/notification/index').then((module) => {
      const app = module.default;
      app();
      console.log("jky app [notification]:loaded")
      return true;
    }).catch(() => {
      console.log("jky app [notification]:fail")
      return false
    });

    // 粘性购物车
    if(window?.pageInfo?.template?.startsWith("product")) {
      const dom = $("jky-sticky-cart");
      $(window).on('scroll', () => {
        const scroll = $(window).scrollTop();
        if(scroll > 250 && !dom.hasClass('active')) {
          if (!customElements.get('jky-sticky-cart')) {
            import(/* webpackChunkName: "sticky-cart-new-4-0-13" */ '../../plugins/sticky-cart/index').then((module) => {
              const app = module.default;
              app();
              console.log("jky app [sticky-cart]:loaded")
              return true;
            }).catch(() => {
              console.log("jky app [sticky-cart]:fail")
              return false
            });
          }
          dom.addClass('active')
        }
        if(scroll <= 250 && dom.hasClass('active')) {
          dom.removeClass('active')
        }
      })
    }

    // 心愿单
    if(window?.pageInfo?.settings?.open_wishlist && window?.pageInfo?.template?.startsWith("product")) {
      import(/* webpackChunkName: "wishlist-new-4-0-3" */ '../../plugins/wishlist/index').then((module) => {
        const app = module.default;
        app();
        console.log("jky app [wishlist]:loaded")
        return true;
      }).catch(() => {
        console.log("jky app [wishlist]:fail")
        return false
      });
    }
    if ($('.pdp-calculator').length > 0) {
      PdpCalculator()
    }
  }, 300);
})
